import { getLogger } from "@expert/logging";
import type { ContentfulClientApi, EntryFieldTypes, EntrySkeletonType } from "contentful";
import type { Language } from "../types";

export interface PersonalizeCoverageResponse {
    deviceName: string;
    examples: string[];
}

interface ExamplesData {
    generic: string[];
    [key: string]: string[];
}

interface PersonalizeCoverageFields {
    deviceName: EntryFieldTypes.Symbol;
    examples: EntryFieldTypes.Object;
}

const logger = getLogger({
    module: "getPersonalizeCoverageExamples",
    supportTeam: "sales",
});

export const getPersonalizeCoverageExamples = async (
    contentfulClient: ContentfulClientApi<undefined>,
    language: Language,
    productSku?: string,
): Promise<PersonalizeCoverageResponse[]> => {
    try {
        const entries = await contentfulClient.withoutUnresolvableLinks.getEntries<
            EntrySkeletonType<PersonalizeCoverageFields>
        >({
            content_type: "personalizeCoverage",
            locale: language,
        });

        if (!entries.items.length) {
            logger.warn("No personalizeCoverage entries found.");
            return [];
        }

        return entries.items.map((entry) => {
            const { deviceName, examples } = entry.fields;
            const exampleData = examples as ExamplesData;
            const genericExamples = Array.isArray(exampleData.generic) ? exampleData.generic : [];
            const productExamples = productSku && Array.isArray(exampleData[productSku]) ? exampleData[productSku] : [];

            return {
                deviceName,
                examples: [...productExamples, ...genericExamples],
            };
        });
    } catch (error) {
        logger.error({ error }, "Error fetching personalize coverage examples:");
        return [];
    }
};
